// TODO: change name to assessmentsApi b/c it contains hooks but is not a hook
// @ts-ignore
import useGetApi from "../useGetApi"
// @ts-ignore
import useMutateApi from "../useMutateApi"

// constants
// @ts-ignore
import apiEndpoints from "api/utils/apiEndpoints"
// @ts-ignore
import queryKeys from "api/utils/queryKeys"

// utils
// @ts-ignore
import getUrl from "api/apiMap"

// @ts-ignore
const useGetStudyAssessments = (studyId, deactivated = false) => {
  return useGetApi(
    `${getUrl(apiEndpoints.studies)}${studyId}/assessments/?deactivated=${deactivated ? "true" : "false"}`,
    queryKeys.assessments.list(studyId, deactivated)
  )
}

// @ts-ignore
const usePostRunAllAssessments = (studyId) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(`${apiEndpoints.studies}${studyId}/assessments/run-all`),
    invalidateQueries: [queryKeys.assessments.all],
    successMsg: "Running assessments",
  })
}

// @ts-ignore
const useGetStudyAssessment = (studyId, assessId) => {
  return useGetApi(
    `${getUrl(apiEndpoints.studies)}${studyId}/assessments/${assessId}/`,
    queryKeys.assessments.details(studyId, assessId)
  )
}

// @ts-ignore
const useGetAssessmentHistory = (studyId, assessId) => {
  return useGetApi(
    `${getUrl(apiEndpoints.studies)}${studyId}/assessments/${assessId}/history/`,
    queryKeys.assessments.history(studyId, assessId)
  )
}

// @ts-ignore
const usePostRunAssessment = (studyId, assessId) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.studies)}${studyId}/assessments/${assessId}/run`,
    successMsg: "Successfully ran assessment",
  })
}

// @ts-ignore
const usePostSaveAssessment = (studyId, assessId) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.studies)}${studyId}/assessments/${assessId}/save`,
    invalidateQueries: [queryKeys.assessments.details(studyId, assessId)],
    successMsg: "Successfully saved assessment",
  })
}

// @ts-ignore
const usePostOverrideAssessment = (studyId, assessId) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.studies)}${studyId}/assessments/${assessId}/override`,
    invalidateQueries: [queryKeys.assessments.study(studyId, assessId)],
    successMsg: "Successfully overriden assessment",
  })
}

// @ts-ignore
const usePostDisclosurePlan = (studyId, assessId) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.studies)}${studyId}/assessments/${assessId}/disclosure-plan`,
    invalidateQueries: [queryKeys.assessments.disclosurePlan(studyId, assessId)],
    successMsg: "Successfully updated disclosure plan",
  })
}

const usePostAssessmentActivity = (studyId: string | undefined, assessId: string | number | undefined) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.studies)}${studyId}/assessments/${String(assessId)}/create-attach-project`,
    invalidateQueries: [queryKeys.assessments.all, queryKeys.studies.activities(studyId)],
    successMsg: "Successfully updated the assessment's linked activities",
  })
}

// @ts-ignore
const usePutMissingFields = (authId, deactivated) => {
  return useMutateApi({
    method: "put",
    apiEndpoint: `${getUrl(apiEndpoints.authoring)}${authId}/partial-update`,
    invalidateQueries: [queryKeys.assessments.all, queryKeys.assessments.list(authId, deactivated)],
  })
}

const usePostAssessmentTag = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(apiEndpoints.tags),
    invalidateQueries: [],
  })
}

export {
  // assessments
  useGetStudyAssessments,
  usePostRunAllAssessments,
  usePostDisclosurePlan,
  // assessment
  useGetStudyAssessment,
  useGetAssessmentHistory,
  usePostRunAssessment,
  usePostSaveAssessment,
  usePostOverrideAssessment,
  usePostAssessmentActivity,
  usePutMissingFields,
  usePostAssessmentTag,
}
